module.exports = __webpack_public_path__ + "img/pelican.33befbdf.svg";